import { Theme } from '@mui/material/styles';

export const getMuiDialogTitle = (theme: Theme): Record<string, unknown> => ({
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        alignContent: 'center',
        display: 'grid',
        gridGap: theme.spacing(0.75),
        gridTemplateColumns: '1fr auto 1fr',
        gridTemplateRows: '1fr',
        justifyContent: 'space-between',
        padding: theme.spacing(1.25, 2),

        '& button': {
          padding: 0,
        },

        '& .iconLeft': {
          gridArea: '1/1/1/1',
          justifySelf: 'start',

          '&.MuiIconButton-colorSecondary:hover': {
            backgroundColor: 'transparent',
          },
        },

        '& .iconRight': {
          display: 'none',
          gridArea: '1/3/1/3',
          justifySelf: 'end',

          '&.MuiIconButton-colorSecondary:hover': {
            backgroundColor: 'transparent',
          },
        },

        '& .MuiIconButton-colorSecondary:hover .fd-icon svg': {
          color: theme.palette.common.black,
        },

        [theme.breakpoints.up('sm')]: {
          padding: theme.spacing(2, 2.5),
        },
      },
    },
  },
});
